import { getJSON } from 'common/services/api'
import { NAMESPACE } from 'locale'
import { cqiConstants } from 'locale/cqi'
import { type TFunction, useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import BaseCQITable from './BaseCQITable'
import {
  CQI_BASE_URL,
  CQITabID,
  getRoundedPercentage,
  type TablesDataSource
} from './utils'

const CQI_EFFECTIVE_URL = `${CQI_BASE_URL}/effective`

export type EffectiveDataFetched = {
  carePlansSigned: number
}

const EffectiveTable = () => {
  const { t } = useTranslation(NAMESPACE.CQI)

  const { data, isLoading } = useQuery<{ result: EffectiveDataFetched }>(
    ['cqi', CQITabID.Effective],
    () => getJSON({ url: CQI_EFFECTIVE_URL })
  )

  return (
    <BaseCQITable
      tabID={CQITabID.Effective}
      isLoading={isLoading}
      dataSource={getEffectiveData(t, data?.result)}
    />
  )
}

export const getEffectiveData = (
  t: TFunction<string, undefined>,
  props: EffectiveDataFetched | undefined
): TablesDataSource[] => {
  let output: string | undefined

  if (props !== undefined && props.carePlansSigned !== undefined) {
    output = getRoundedPercentage(props.carePlansSigned)
  }

  return [
    {
      key: t(cqiConstants.SIGNED_SUPPORT_PLANS),
      indicator: t(cqiConstants.SIGNED_SUPPORT_PLANS),
      timeframe: t(cqiConstants.SIX_MONTHS),
      output
    }
  ]
}

export default EffectiveTable
